<template>
    <div>
        <b-modal
            :id="'modal-create-lesson-' + module.id"
            title="Criar Aula"
            size="lg"
            no-close-on-backdrop
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit.stop.prevent="submit">

                    <!-- Field -->
                    <b-form-group
                        label="Título da Aula *">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                        ></b-form-input>
                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Url do Vídeo do Youtube/Vimeo/Bunny/PandaVideo *"
                        description="Basta copiar o link para conseguirmos incorporar o vídeo na aula">
                        <!-- Input -->
                        <b-form-input
                            type="text"
                            v-model="form.video_url"
                        ></b-form-input>
                        <!-- Error -->
                        <has-errors :errors="errors" name="video_url" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Conteúdo">

                        <!-- Input -->
                        <quill-editor
                            ref="myQuillEditor"
                            v-model="form.content"
                            :options="editorOption">
                        </quill-editor>

                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Material Complementar"
                        description="Anexe arquivos que vão ajudar o seu aluno na conclusão dessa aula.">

                        <b-form-file
                            ref="lessonFiles"
                            @input="loadLessonFiles"
                            placeholder=""
                            browse-text="Procurar"
                            no-drop
                        ></b-form-file>
                    </b-form-group>

                    <div class="mb-3 row">
                        <div v-for="(lessonFileItem, key) in form.files" :key="lessonFileItem.id" class="col-sm-12 d-flex">
                            <div class="text-muted">
                                <i class="fas fa-file mr-2"></i>
                                {{ lessonFileItem.name }}
                            </div>
                            <div class="ml-3 text-right">
                                <a :href="lessonFileItem.preview" target="_blank">
                                    Ver Prévia
                                </a>

                                <a href="javascript:void(1);" @click="removeLessonFile(key)" class="text-danger ml-2">
                                    Remover
                                </a>
                            </div>
                        </div>
                    </div>

                    <b-alert :show="loadingLessonFile" variant="info">
                        <b-spinner class="mr-2" size="sm"></b-spinner>
                        Salvando arquivo ....
                    </b-alert>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Criar Aula
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'

export default {
    props: ['module'],
    components: {
        quillEditor,
    },
    data() {
        return {
            loading: false,
            loadingLessonFile: false,
            errors: {},
            form: {
                name: null,
                content: null,
                video_url: null,
                files: []
            },
            editorOption: {
                placeholder: 'Uma texto de apoio sobre a aula ...',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        ['link', 'image'],
                        ['clean', {'align': [] }]
                    ],
                }
            },
        }
    },
    created() {
        this.$root.$on('open-modal-create-lesson-' + this.module.id, () => {
            this.$bvModal.show('modal-create-lesson-' + this.module.id);
        })
    },
    methods: {
        submit() {
            this.loading = true;

            axios.post('/teacher/courses/' + this.module.course_id + '/modules/' + this.module.id + '/lessons', {
                ...this.form,
                files: this.form.files.map((item) => {
                    return item.id
                })
            })
                .then(response => {

                    // Callback
                    this.$emit('created')

                    // Close Modal
                    this.$bvModal.hide('modal-create-lesson-' + this.module.id)

                    // Message
                    this.$toast.success('Aula criada com sucesso!')

                    // Clear Form
                    this.form = {
                        name: null,
                        content: null,
                        video_url: null,
                        files: []
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch(errors => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async loadLessonFiles() {
            for (let index = 0; index < this.$refs.lessonFiles.files.length; index++) {
                const file = this.$refs.lessonFiles.files[index];
                if (file.size < 52428800) {
                    await this.uploadLessonFile(this.$refs.lessonFiles.files[index])
                } else {
                    alert('O arquivo ' + file.name + ' é muito grande. O tamanho máximo permitido é 50MB.')
                }
            }
        },

        async uploadLessonFile(inputFile) {

            this.loadingLessonFile = true;

            let formData = new FormData();
            formData.append('lesson-file', inputFile)

            await axios.post('/teacher/lessons-files', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((result) => {
                    let response = result.data.data;

                    if (response.file) {
                        this.form.files.push(response.file);
                    }
                })
                .finally(() => this.loadingLessonFile = false)
        },

        removeLessonFile(key) {
            this.form.files.splice(key, 1)
        },
    }
}
</script>

<style scoped>

</style>
